import { useCallback, useEffect, useState } from 'react';
import type { Tabs } from '../interfaces/GlobalContext.interface';
import useBrowserMode from '../shared/hooks/useBrowserMode';

const STORAGE_KEY = 'select-tab';
const EMPRESAS_PATH_FRAGMENT = '/tienda-empresas/';
const TAB_EMPRESAS: Tabs = 'empresas';
const TAB_PERSONAS: Tabs = 'personas';

export const useSelectTab = () => {
    const { isBrowser } = useBrowserMode();

    const [selectedTab, setSelectedTab] = useState<Tabs | undefined>(() => {
        if (!isBrowser) return undefined;

        const isEmpresasUrl = window.location.pathname.includes(EMPRESAS_PATH_FRAGMENT);
        
        if (isEmpresasUrl) return TAB_EMPRESAS;

        const storedValue = localStorage.getItem(STORAGE_KEY) as Tabs;
        if (storedValue) return storedValue;

        return TAB_PERSONAS;
    });

    const setSelection = useCallback((selection: Tabs) => {
        try {
            localStorage.setItem(STORAGE_KEY, String(selection));
            setSelectedTab(selection);
        } catch (error) {
            console.error('Error saving tab selection:', error);
            setSelectedTab(selection);
        }
    }, []);

    useEffect(() => {
        if (!isBrowser) return;

        const isEmpresasUrl = window.location.pathname.includes(EMPRESAS_PATH_FRAGMENT);
        const storedValue = localStorage.getItem(STORAGE_KEY);

        if (isEmpresasUrl && storedValue !== TAB_EMPRESAS) {
            localStorage.setItem(STORAGE_KEY, TAB_EMPRESAS);
        }
    }, [isBrowser]);

    return {
        selectedTab,
        setSelectionToLocalStorage: setSelection,
    };
};